import React, {useCallback} from 'react';
import {useIntl} from 'react-intl';

import {useCustomerMgr, useNotify} from 'coreHooks';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

import {socialLoginErrorTypes} from './config';
import {ISocialLoginProps} from './ISocialLogin';
import messages from './messages';
import {SocialLoginContextProvider} from './SocialLoginContext';
import {SocialLoginLine} from './Subcomponents';

const SocialLogin = ({children, classNames}: ISocialLoginProps) => {
	const {managerRepository} = useGeneralProvider();
	const CustomerMgr = useCustomerMgr();
	const intl = useIntl();
	const notify = useNotify();

	const onLogin = useCallback(async (identityProviderName: string, isRedirectLogin: boolean) => {
		const identityProvider = await managerRepository.getIdentityProvidersMgr().getProvider(identityProviderName);

		if (!identityProvider) {
			return;
		}

		if (isRedirectLogin) {
			localStorage.setItem('identityProviderName', identityProviderName);
			sessionStorage.setItem('redirectUrl', location.pathname);

			return identityProvider.redirectToIdentityProvider();
		}

		const providerCredentials = await identityProvider.getProviderCredentials();

		if (!providerCredentials) {
			return;
		}

		try {
			await CustomerMgr.loginCustomer(providerCredentials);

			const customer = CustomerMgr.getCurrentCustomer();

			if (!customer.isGuest) {
				if (customer.newsletter) {
					CustomerMgr.getNewsletterProfile(customer.email);
				}

				CustomerMgr.joinToLoyalty();
			}
		} catch (e) {
			const errorMessage = intl.formatMessage(
				e.message in socialLoginErrorTypes ? messages[socialLoginErrorTypes[e.message]] : messages.error,
			);

			notify.error(errorMessage);
		}
	}, []);

	return (
		<SocialLoginContextProvider value={{onLogin}}>
			<div className={classNames}>
				{children}
			</div>
		</SocialLoginContextProvider>
	);
};

SocialLogin.Line = SocialLoginLine;

export default SocialLogin;
